import { Check, Clear, Remove } from '@mui/icons-material';
import { Avatar, ListItem, Typography, useTheme } from '@mui/material';
import { type FC, useState } from 'react';
import type { HygieneItemType, HygieneStatusVisitDatesTrend } from '../../../models';
import { extractHygieneColors } from '../../../utils';
import { LightboxGallery } from '../../Dialogs';

export interface AvaniHygieneTrendsCardProps {
  trend: HygieneStatusVisitDatesTrend;
  category: HygieneItemType;
  index: number;
}

export const AvaniHygieneTrendsCard: FC<AvaniHygieneTrendsCardProps> = ({ trend, category, index }) => {
  const { media, hygieneStatus, date } = trend;
  const theme = useTheme();
  const id = `trends ${category} ${index}`;
  const trendDate = new Date(date);

  // Decorate avatars with outline, which have media
  const hasMedia = !!media?.length;
  const [toggle, setToggle] = useState(false);
  const handleClose = () => {
    setToggle(false);
  };

  const { color, bg } = extractHygieneColors(hygieneStatus, theme);

  return (
    <ListItem
      disablePadding
      key={index}
      id={id}
      onClick={() => setToggle(true)}
      sx={{
        cursor: hasMedia ? 'pointer' : '',
        display: 'block',
        width: 'auto',
        minWidth: '80px',
        float: 'left',
        padding: '0 12px 0 0',
        minHeight: '60px'
      }}
    >
      <Avatar
        sx={{
          margin: '0 auto',
          backgroundColor: bg,
          border: hasMedia ? `2px solid ${theme.colors.avani.teal}` : ''
        }}
      >
        {hygieneStatus === null ? (
          <Remove sx={{ fill: color }} />
        ) : hygieneStatus ? (
          <Check sx={{ fill: color }} />
        ) : (
          <Clear sx={{ fill: color }} />
        )}
      </Avatar>
      <Typography variant={'body2'} color={color} sx={{ width: '100%', textAlign: 'center' }}>
        {`${trendDate.getDate()}/${trendDate.getMonth() + 1}`}
      </Typography>
      {hasMedia && (
        <LightboxGallery open={toggle} index={0} handleClose={handleClose} imageSrc={trend.media ?? []} theme={theme} />
      )}
    </ListItem>
  );
};
